import React, { useEffect, useRef, useState } from 'react'
import { Button, Col, Form, FormGroup, Input, Row, Modal, UncontrolledTooltip } from "reactstrap";
import EditButton from "./EditButton";
import Select from "react-select";

const ProcedureArchiveTable = ({ procedures, opk507 }) => {
    const valueConvert = (val) => {
        let nr = Number(val).toFixed(2).toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1 ').replace(".", ",")
        return nr === "NaN" ? " X " : nr
    }
    const [idtoEdit, setIdEdit] = React.useState(null)
    return (
        <table className='table table-border tableWycena'>
                <thead className=''>
                <tr className=''>
                    <th className="headerColor">Kod procedury <br></br>(wg ICD-9)</th>
                    <th className="headerColor">Nazwa procedury <br></br>(wg IC-D9)</th>
                    <th className="headerColor">Kod procedury <br></br>(wg świadczeniodawcy)</th>
                    <th className="headerColor">Nazwa procedury<br></br> (wg świadczeniodawcy)</th>
                    <th className="headerColor">Numer OPK</th>
                    <th className="headerColor">Daty obowiązywania</th>
                    {/* <th className="headerColor">Opcje</th> */}
                </tr>
                </thead>
                <tbody>
                {procedures && Object.getOwnPropertyNames(procedures).length !== 0 && procedures.map((elem) => {
                    return <>
                        {idtoEdit !== elem.id ? <tr>
                            <td>{elem.icd_code_slow}</td>
                            <td>{elem.name_slow}</td>
                            <td>{elem.icd_code}</td>
                            <td>{elem.name}</td>
                            <td>{elem.opk_name_number}</td>
                            <td>{<>{elem.year_from !==1900 ? <>od {elem.month_from}.{elem.year_from} </>:""} 
                            {elem.year_to !== 2100?<>do {elem.month_to}.{elem.year_to}</>:""}</>}</td>
                            {/* <td className='text-center'>
                                <ArchiveButton idx={elem.id} elem={elem} showArchive={showArchive}/> 
                            </td> */}
                            {/* {idtoEdit !==elem.id ? <td onClick={()=>{seIdelement(elem)}}>Edytuj</td>:<td>
                    <span style={{marginRight:"5px", cursor:"pointer"}} onClick={()=>{setIdEdit(null)}}>
                    Anuluj</span>&nbsp;&nbsp;<span style={{marginLeft:"5px"}}>OK</span></td>} */}
                        </tr> : <tr></tr>
                            // <tr>
                            //     <td>
                            //         <Input
                            //             className="border-input"
                            //             type="text"
                            //             id="procedurestaff_opk_edit"
                            //             value={formValuesEdit['procedurestaff_opk_edit']}
                            //             onChange={(e)=>{}}
                            //         />
                            //     </td>
                            //     <td>
                            //         <Input
                            //             className="border-input"
                            //             type="text"
                            //             id="staff_type_edit"
                            //             value={formValuesEdit['staff_type_edit']}
                            //             onChange={(e)=>{}}

                            //         /></td>
                            //     <td><Input
                            //             className="border-input"
                            //             type="text"
                            //             id="rate_hour_edit"
                            //             value={formValuesEdit['rate_hour_edit']}
                            //             onChange={(e)=>{}}

                            //         /></td>
                            //     <td><Input
                            //             className="border-input"
                            //             type="text"
                            //             id="rate_min_edit"
                            //             value={formValuesEdit['rate_min_edit']}
                            //             onChange={(e)=>{}}

                            //         /></td>
                            //     <td className='rightAlignCell'><Input
                            //             className="border-input"
                            //             type="text"
                            //             id="rate_proc_edit"
                            //             value={formValuesEdit['rate_proc_edit']}
                            //             onChange={(e)=>{}}

                            //         /></td>
                            //     <td><span className="editButtonMat" onClick={()=>{setIdEdit(null)}}>Anuluj</span><span style={{cursor:"pointer"}}>OK</span></td>
                            //     </tr>
                        }

                    </>
                })}
                </tbody>
            </table>
    )
}
export default ProcedureArchiveTable;
